export const factAggRules = [
  {
    "Fact Type 1": "distribution",
    "Fact Type 2": "distribution",
    "Chart": "Stacked Bar Chart",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "distribution",
    "Fact Type 2": "difference",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "difference",
    
  },
  {
    "Fact Type 1": "distribution",
    "Fact Type 2": "rank",
    "Chart": "Horizontal Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "rank",
    
  },
  {
    "Fact Type 1": "distribution",
    "Fact Type 2": "categorization",
    "Chart": "Isotype Bar Chart",
    "Measure": "distribution",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "distribution",
    "Fact Type 2": "value",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "distribution",
    "Fact Type 2": "extreme",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "extreme",
    
  },
  {
    "Fact Type 1": "distribution",
    "Fact Type 2": "proportion",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "distribution",
    "Fact Type 2": "outlier",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "outlier",
    
  },
  {
    "Fact Type 1": "distribution",
    "Fact Type 2": "association",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "distribution",
    "Fact Type 2": "trend",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "difference",
    "Fact Type 2": "distribution",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "difference",
    
  },
  {
    "Fact Type 1": "difference",
    "Fact Type 2": "difference",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "difference",
    "Fact Type 2": "rank",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "difference",
    "Fact Type 2": "categorization",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "difference",
    "Fact Type 2": "value",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "difference",
    "Fact Type 2": "extreme",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "difference",
    "Fact Type 2": "proportion",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "difference",
    "Fact Type 2": "outlier",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "difference",
    "Fact Type 2": "association",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "difference",
    "Fact Type 2": "trend",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "difference",
    
  },
  {
    "Fact Type 1": "rank",
    "Fact Type 2": "distribution",
    "Chart": "Horizontal Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "rank",
    
  },
  {
    "Fact Type 1": "rank",
    "Fact Type 2": "difference",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "rank",
    "Fact Type 2": "rank",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "rank",
    "Fact Type 2": "categorization",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "rank",
    "Fact Type 2": "value",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "rank",
    "Fact Type 2": "extreme",
    "Chart": "Horizontal Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "rank",
    
  },
  {
    "Fact Type 1": "rank",
    "Fact Type 2": "proportion",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "rank",
    "Fact Type 2": "outlier",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "rank",
    "Fact Type 2": "association",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "rank",
    "Fact Type 2": "trend",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "categorization",
    "Fact Type 2": "distribution",
    "Chart": "Isotype Bar Chart",
    "Measure": "distribution",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "categorization",
    "Fact Type 2": "difference",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "categorization",
    "Fact Type 2": "rank",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "categorization",
    "Fact Type 2": "categorization",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "categorization",
    "Fact Type 2": "value",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "categorization",
    "Fact Type 2": "extreme",
    "Chart": "Isotype Bar Chart",
    "Measure": "extreme",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "extreme",
    
  },
  {
    "Fact Type 1": "categorization",
    "Fact Type 2": "proportion",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "categorization",
    "Fact Type 2": "outlier",
    "Chart": "Isotype Bar Chart",
    "Measure": "outlier",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "outlier",
    
  },
  {
    "Fact Type 1": "categorization",
    "Fact Type 2": "association",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "categorization",
    "Fact Type 2": "trend",
    "Chart": "Isotype Bar Chart",
    "Measure": "trend",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "value",
    "Fact Type 2": "distribution",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "value",
    "Fact Type 2": "difference",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "value",
    "Fact Type 2": "rank",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "value",
    "Fact Type 2": "categorization",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "value",
    "Fact Type 2": "value",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "value",
    "Fact Type 2": "extreme",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "value",
    "Fact Type 2": "proportion",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "value",
    "Fact Type 2": "outlier",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "value",
    "Fact Type 2": "association",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "value",
    "Fact Type 2": "trend",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "extreme",
    "Fact Type 2": "distribution",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "extreme",
    
  },
  {
    "Fact Type 1": "extreme",
    "Fact Type 2": "difference",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "extreme",
    "Fact Type 2": "rank",
    "Chart": "Horizontal Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "rank",
    
  },
  {
    "Fact Type 1": "extreme",
    "Fact Type 2": "categorization",
    "Chart": "Isotype Bar Chart",
    "Measure": "extreme",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "extreme",
    
  },
  {
    "Fact Type 1": "extreme",
    "Fact Type 2": "value",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "extreme",
    "Fact Type 2": "extreme",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "extreme",
    "Fact Type 2": "proportion",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "extreme",
    "Fact Type 2": "outlier",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "extreme+outlier",
    
  },
  {
    "Fact Type 1": "extreme",
    "Fact Type 2": "association",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "extreme",
    "Fact Type 2": "trend",
    "Chart": "Line Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "extreme",
    
  },
  {
    "Fact Type 1": "proportion",
    "Fact Type 2": "distribution",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "proportion",
    "Fact Type 2": "difference",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "proportion",
    "Fact Type 2": "rank",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "proportion",
    "Fact Type 2": "categorization",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "proportion",
    "Fact Type 2": "value",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "proportion",
    "Fact Type 2": "extreme",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "proportion",
    "Fact Type 2": "proportion",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "proportion",
    "Fact Type 2": "outlier",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "proportion",
    "Fact Type 2": "association",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "proportion",
    "Fact Type 2": "trend",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "outlier",
    "Fact Type 2": "distribution",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "outlier",
    
  },
  {
    "Fact Type 1": "outlier",
    "Fact Type 2": "difference",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "outlier",
    "Fact Type 2": "rank",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "outlier",
    "Fact Type 2": "categorization",
    "Chart": "Isotype Bar Chart",
    "Measure": "outlier",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "outlier",
    
  },
  {
    "Fact Type 1": "outlier",
    "Fact Type 2": "value",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "outlier",
    "Fact Type 2": "extreme",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "extreme+outlier",
    
  },
  {
    "Fact Type 1": "outlier",
    "Fact Type 2": "proportion",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "outlier",
    "Fact Type 2": "outlier",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "outlier",
    "Fact Type 2": "association",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "outlier",
    "Fact Type 2": "trend",
    "Chart": "Line Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "outlier",
    
  },
  {
    "Fact Type 1": "association",
    "Fact Type 2": "distribution",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "association",
    "Fact Type 2": "difference",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "association",
    "Fact Type 2": "rank",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "association",
    "Fact Type 2": "categorization",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "association",
    "Fact Type 2": "value",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "association",
    "Fact Type 2": "extreme",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "association",
    "Fact Type 2": "proportion",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "association",
    "Fact Type 2": "outlier",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "association",
    "Fact Type 2": "association",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "association",
    "Fact Type 2": "trend",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "trend",
    "Fact Type 2": "distribution",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "trend",
    "Fact Type 2": "difference",
    "Chart": "Vertical Bar Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "difference",
    
  },
  {
    "Fact Type 1": "trend",
    "Fact Type 2": "rank",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "trend",
    "Fact Type 2": "categorization",
    "Chart": "Isotype Bar Chart",
    "Measure": "trend",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "trend",
    "Fact Type 2": "value",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "trend",
    "Fact Type 2": "extreme",
    "Chart": "Line Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "extreme",
    
  },
  {
    "Fact Type 1": "trend",
    "Fact Type 2": "proportion",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "trend",
    "Fact Type 2": "outlier",
    "Chart": "Line Chart",
    "Measure": "equal",
    "Subspace": "equal",
    "Groupby": "equal",
    "Focus": "outlier",
    
  },
  {
    "Fact Type 1": "trend",
    "Fact Type 2": "association",
    "Chart": "juxtaposition",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  },
  {
    "Fact Type 1": "trend",
    "Fact Type 2": "trend",
    "Chart": "Stacked Line Chart",
    "Measure": "",
    "Subspace": "",
    "Groupby": "",
    "Focus": "",
    
  }
]